module.exports = __webpack_public_path__ + "static/auto_7-1a0a7a916d5ce4c62be2172b68ff0c14.jpg";